exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-analytic-studio-studios-___studios__container___1OvN8 {\n  display: flex;\n  justify-content: center;\n  width: 95%;\n  margin: 0 auto;\n}\n\n.src-components-analytic-studio-studios-___studios__studioCards___2SfNc {\n  display: flex;\n  flex-wrap: wrap;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-analytic-studio-studios-___studios__container___1OvN8",
	"studioCards": "src-components-analytic-studio-studios-___studios__studioCards___2SfNc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/analytic-studio/studios/studios.scss
// module id = 2434
// module chunks = 0